module.exports = __webpack_public_path__ + "img/icon_2_13.3b2b610b.png";